import { createActionSet, createNoPropsAction, createRequestAction, createSuccessAction } from "@app/root-store/actions/action-creators";
import { User as FirebaseUser } from "firebase/auth";
import { AuthUser, AuthenticationReqs, ResetPasswordRequestParams, ValidateInviteCodeRequestParams } from "../../model/auth-user";

export interface LoginRedirectObj {
    redirectTo?: string;
    message?: string;
    code?: string;
}

const category = "Auth";
const pwCategory = "Password";
const inviteCategory = "Invite Code";

export const clearError = createNoPropsAction(category, "Clear Error State");
export const watchLogin = createNoPropsAction(category, "Watch Login");
export const clearErrorPendingTrue = createNoPropsAction(category, "Clear Error with Pending True");
export const stopPendingLogin = createNoPropsAction(category, "Stop Pending Login");
export const loggingIn = createNoPropsAction(category, "Logging In");
export const processLogin = createRequestAction<{ token: string; inviteCode?: string; redirect?: any; user?: FirebaseUser }>(
    category,
    "Process Login"
);

export const logIn = createNoPropsAction(category, "Log In");
export const logInSuccess = createSuccessAction<{ authUser: AuthUser; redirect?: string }>(category, "Log In");
export const logInFailure = createRequestAction<LoginRedirectObj>(category, "Log In Failure");
export const logInRedirect = createRequestAction<LoginRedirectObj>(category, "Log In Redirect");

export const logOut = createRequestAction<LoginRedirectObj>(category, "Log Out");
export const logOutSuccess = createNoPropsAction(category, "Log Out Success");
export const logOutConfirmation = createNoPropsAction(category, "Log Out Confirmation");
export const logOutConfirmationDismiss = createNoPropsAction(category, "Log Out Confirmation Dismiss");

export const register = createSuccessAction<AuthenticationReqs>(category, "Register");
export const registerFailure = createRequestAction<{ message?: string; authUser?: AuthenticationReqs }>(category, "Register Failure");

export const { request: resetPassword, success: resetPasswordSuccess } = createActionSet<{ email: string }>(pwCategory, "Reset");
export const resetPasswordFailure = createRequestAction<{ errorCode?: string; message?: string }>(pwCategory, "Reset Failure");

export const { request: changePassword, success: changePasswordSuccess } = createActionSet<ResetPasswordRequestParams>(
    pwCategory,
    "Change"
);
export const changePasswordFailure = createRequestAction<{ errorCode?: string; message?: string }>(pwCategory, "Change Failure");

export const { request: verifyPassword, success: verifyPasswordSuccess } = createActionSet<ResetPasswordRequestParams>(
    pwCategory,
    "Verify Reset"
);
export const verifyPasswordFailure = createRequestAction<{ errorCode?: string; message?: string }>(pwCategory, "Verify Failure");

export const validateInviteCode = createRequestAction<ValidateInviteCodeRequestParams>(inviteCategory, "Validate");
export const validateInviteCodeSuccess = createRequestAction<{ isInviteCodeValid?: boolean; message?: string }>(
    inviteCategory,
    "Validate Success"
);
export const validateInviteCodeFailure = createRequestAction<{ message?: string }>(
    inviteCategory,
    "Validate Failure"
);
